import { Form, Input, Select, Button, message, Row, Col, Space, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useState, useEffect, useRef } from "react";
import AnimateItems from "../../../../utils/AnimateItems";
import axios from "axios";
import { tiposconcentracion, tiposinstalacion, tiposverificacion } from "../formOptions";

export default function ClasificacionForm(props) {
  const { title, visible, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [otraInstalacionVisible, setOtraInstalacionVisible] = useState(false);
  const [concentracionPublicaVisible, setConcentracionPublicaVisible] = useState(false);
  const [objetosSolicitud, setObjetosSolicitud] = useState([]);
  const [tiposTension, setTiposTension] = useState([]);
  const otraInstalacionRef = useRef();
  const concentracionPublicaRef = useRef();
  const [form] = Form.useForm();

  const colProps = {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 12,
    xl: 12,
    xxl: 12,
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/cat_objetossolicitud`).then((res) => {
      setObjetosSolicitud(res.data);
    });
    axios.get(`${process.env.REACT_APP_API_URL}/cat_tipostension`).then((res) => {
      setTiposTension(res.data);
    });
  }, []);

  useEffect(() => {
    form.setFieldsValue(verification);
  }, [visible, verification, form]);

  useEffect(() => {
    const value = verification?.TipoInstalacionID;
    if (value === 2 || value === 4 || value === 6 || value === 8) {
      setConcentracionPublicaVisible(true);
      setOtraInstalacionVisible(false);
    } else if (value === 5) {
      setConcentracionPublicaVisible(false);
      setOtraInstalacionVisible(true);
    } else {
      setConcentracionPublicaVisible(false);
      setOtraInstalacionVisible(false);
    }
  }, [verification?.TipoInstalacionID]);

  useEffect(() => {
    if (otraInstalacionVisible) {
      otraInstalacionRef?.current?.focus();
    } else if (concentracionPublicaVisible) {
      concentracionPublicaRef?.current?.focus();
    }
  }, [otraInstalacionVisible, concentracionPublicaVisible]);

  const clearSelectProps = {
    style: { width: "100%" },
    allowClear: true,
    clearIcon: <CloseOutlined style={{ color: "red" }} />,
    showSearch: true,
    filterOption: (input, option) => option.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0,
  };

  return (
    <>
      <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800}>
        <Form form={form} layout="vertical" initialValues={verification}>
          <AnimateItems delay={0.15}>
            <Row gutter={[40, 0]}>
              <Col {...colProps}>
                <Form.Item name="ObjetoSolicitudID" label="Objeto de la solicitud">
                  <Select {...clearSelectProps}>
                    {objetosSolicitud.map((item) => (
                      <Select.Option key={item.ObjetoSolicitudID} value={item.ObjetoSolicitudID}>
                        {item.ObjetoSolicitud}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="TipoTensionID" label="Tipo de tensión">
                  <Select {...clearSelectProps}>
                    {tiposTension.map((item) => (
                      <Select.Option key={item.TipoTensionID} value={item.TipoTensionID}>
                        {item.TipoTension}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="TipoVerificacionID" label="Tipo de verificación">
                  <Select {...clearSelectProps}>
                    {tiposverificacion.map((tipo) => (
                      <Select.Option key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="TipoInstalacionID" label="Tipo de instalación">
                  <Select
                    onChange={(value) => {
                      if (value === 2 || value === 4 || value === 6 || value === 8) {
                        setConcentracionPublicaVisible(true);
                        setOtraInstalacionVisible(false);
                      } else if (value === 5) {
                        setConcentracionPublicaVisible(false);
                        setOtraInstalacionVisible(true);
                      } else {
                        setConcentracionPublicaVisible(false);
                        setOtraInstalacionVisible(false);
                      }
                    }}
                    {...clearSelectProps}
                  >
                    {tiposinstalacion.map((tipo) => (
                      <Select.Option key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="TipoInstalacionOtro" label="Otro tipo de instalación" hidden={!otraInstalacionVisible}>
                  <Input ref={otraInstalacionRef} placeholder="Especifique otro tipo de instalación" />
                </Form.Item>
                <Form.Item name="TipoConcentracionID" label="Tipo de concentración" hidden={!concentracionPublicaVisible}>
                  <Select {...clearSelectProps} ref={concentracionPublicaRef}>
                    {tiposconcentracion.map((tipo) => (
                      <Select.Option key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col {...colProps}>
                <Form.Item name="Nom007" label="Aplica NOM 007">
                  <Select {...clearSelectProps}>
                    <Select.Option value="Sí">Sí</Select.Option>
                    <Select.Option value="No">No</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item name="Nom013" label="Aplica NOM 013">
                  <Select {...clearSelectProps}>
                    <Select.Option value="Sí">Sí</Select.Option>
                    <Select.Option value="No">No</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </AnimateItems>
        </Form>
        <div style={{ textAlign: "right" }}>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                const verificationData = { ...verification, ...form.getFieldsValue() };
                axios
                  .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification?.VerificacionID}`, verificationData)
                  .then(() => {
                    setVisible(false);
                    axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/${verification?.VerificacionID}`).then((res) => {
                      setVerification(res.data[0]);
                      message.success("Campos actualizados correctamente");
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                    message.error("Error al actualizar los campos");
                  });
              }}
            >
              Guardar
            </Button>
            <Button
              onClick={() => {
                setVisible(false);
              }}
            >
              Cancelar
            </Button>
          </Space>
        </div>
      </Modal>
    </>
  );
}
